import { keyframes } from 'tss-react'
import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    position: 'absolute',
    top: 12,
    left: 12,
    right: 48, // space for map controls
    zIndex: '4',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: 350,
  },
  field: {
    display: 'flex',
  },
  icon: {
    color: 'rgba(0, 0, 0, 0.54)',
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  listItem: {
    animation: `${keyframes`
      0% { transform: scale(0), }
      100% { transform: scale(1), }
    `} 0.5s cubic-bezier(0.7, 0, 0, 1) 0.8s backwards`,
    '&:nth-child(1)': {
      animationDelay: '0.1s',
    },
    '&:nth-child(2)': {
      animationDelay: '0.2s',
    },
    '&:nth-child(3)': {
      animationDelay: '0.3s',
    },
    '&:nth-child(4)': {
      animationDelay: '0.4s',
    },
    '&:nth-child(5)': {
      animationDelay: '0.5s',
    },
  },
}))
